// extracted by mini-css-extract-plugin
export default {"header":"styles_header__cnShx","logo":"styles_logo__JCwtg","body":"styles_body__rD1TC","button":"styles_button__c96q5","books":"styles_books__CjI4r","book":"styles_book__qe5Jh"};